/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Toggle/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Toggle({
  children,
  viewPath = "/DesignSystem/EditAutomation/AutomationType/Toggle"
  
}) {
let typeTextValueData = fromData.useDataValue({ viewPath,
context: 'type',
path: 'text',
})
let typeSelectedValueData = fromData.useDataValue({ viewPath,
context: 'type',
path: 'selected',
})
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="type.text"
 text={typeTextValueData}
 onClick={onClick}
 data="type.selected"
 isSelected={typeSelectedValueData}
/>
{children}
</React.Fragment>)
}